<template>
  <div v-if="changes.length >= 2" class="d-flex justify-content-center mb-3">
    <div class="d-inline-flex flex-column align-items-start mw-100">
      <b-button
        variant="light"
        class="d-inline-flex align-items-center flex-wrap fs-13 text-muted text-decoration-none px-3 py-1"
        :aria-expanded="expanded ? 'true' : 'false'"
        @click="expanded = !expanded"
      >
        <span class="font-weight-bold text-dark mr-1">{{ event.actor }}</span>
        {{ event.description }}
        <span class="mx-1">·</span>
        <span class="font-weight-bold" style="color: #163D7D">{{ changes.length }} cambios</span>
        <span class="ml-1" style="color: #a3acb8">· {{ time }}</span>
        <svg class="ml-2" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path :d="expanded ? 'M18 15l-6-6-6 6' : 'M6 9l6 6 6-6'" />
        </svg>
      </b-button>

      <div v-if="expanded" class="border-left pl-3 ml-3 mt-2 fs-13 text-muted" style="border-width: 2px !important">
        <div v-for="change in changes" :key="change.field" class="mb-1">
          {{ change.label }}:
          <span style="text-decoration: line-through">{{ change.from || '—' }}</span>
          →
          <span class="font-weight-bold text-dark">{{ change.to || '—' }}</span>
        </div>
      </div>
    </div>
  </div>

  <div
    v-else
    class="d-flex flex-wrap align-items-center justify-content-center fs-13 text-muted mb-3"
    style="word-break: break-word"
  >
    <span class="font-weight-bold text-dark mr-1">{{ event.actor }}</span>
    <span>{{ event.description }}</span>

    <template v-if="changes.length === 1">
      <span class="mx-1">·</span>
      <span>
        {{ changes[0].label }}:
        <span style="text-decoration: line-through">{{ changes[0].from || '—' }}</span>
        →
        <span class="font-weight-bold text-dark">{{ changes[0].to || '—' }}</span>
      </span>
    </template>

    <span class="ml-1" style="color: #a3acb8">· {{ time }}</span>
  </div>
</template>

<script>
export default {
  name: 'DrawingRequestShowEvent',
  props: {
    event: { type: Object, required: true }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    changes () {
      return (this.event.payload && this.event.payload.changes) || []
    },
    time () {
      return new Date(this.event.created_at).toLocaleTimeString('es-CR', { hour: 'numeric', minute: '2-digit' })
    }
  }
}
</script>
